export const FactIpcaCurveService = (supabase) => {
  const getCurveFrom = async (date) => {
    const { data } = await supabase.from("fact_ipca_curve").select("tenor,rate").eq("date", date).order("tenor")
    return data
  }

  return { getCurveFrom }
}
